const formdata = [
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "230px",
    btx: true,
    lablewith: "90px",
    options: [],
  },
  {
    inputdata: "",
    title: "生产厂商编码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "220px",
    btx: true,
    lablewith: "100px",
    options: [],
  },
  {
    inputdata: "",
    title: "产品名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "100px",
  },
  
  {
    inputdata: "",
    title: "注册证号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "100px",
  },

  {
    inputdata: "",
    title: "显示名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "产品类别",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "220px",
    btx: true,
    lablewith: "100px",
    options: [],
  },
  {
    inputdata: '',
    title: "加价率",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "numberComm",
    width: "230px",
    widths: "230px",
    min: 1,
    max: 100,
    lablewith: "100px"
  },
];

export default formdata;
